export default __webpack_public_path__ + "static/media/Background_00040.cdbc8fb7.png";